import * as React from 'react';
import { History, Location } from 'history';
import { object as PropObject } from 'prop-types';

import { PagedList } from '../gs-core/common';

import { DocListView } from './DocListView';
import { Doc, DocStatus, DocUpload, DocUploadSteps, FilterParamsModel, Subject } from '../common/models';
import { CommonDocLoader, CommonState, ServiceRegistry } from '../services';

interface DocListLoaderProps {
  subjectType?: string;
  subjectUserId?: string;
  owningUnitId?: string;
  onLoading: (loading: boolean) => void;
  onSubjectChange: (subject: Subject | undefined) => void;
  history: History;
  location: Location;
}

interface DocListLoaderState extends CommonState {
  docs?: PagedList<Doc>;
  loading: boolean;
}

export class DocListLoader extends React.Component<DocListLoaderProps, DocListLoaderState> {
  static contextTypes = { services: PropObject };

  constructor(props: DocListLoaderProps) {
    super(props);
    const commonState = CommonDocLoader.createState(props.location);
    this.state = { ...commonState, loading: false };
  }

  async componentWillUpdate(nextProps: DocListLoaderProps) {
    if (nextProps.location !== this.props.location) {
      return this.loadInitialData(nextProps);
    }
  }

  async componentDidMount() {
    return this.loadInitialData(this.props);
  }

  loadInitialData = async (props: DocListLoaderProps) => {
    const { commonLoader, docService, errorLogger } = this.context.services as ServiceRegistry;

    props.onLoading(true);
    this.setState({ loading: true });

    try {
      const initialState = await commonLoader.loadInitialState(props, props.location);
      const docs = await docService.findPage(FilterParamsModel.createFromFull(initialState.filters));

      this.setState(
        { ...initialState, docs },
        () => {
          this.props.onSubjectChange(this.state.selection && this.state.selection.selectedSubject);
        }
      );
    } catch (err) {
      await errorLogger.log(err);
    }

    this.setState({ loading: false });
    props.onLoading(false);
  };

  changePage = (page: number) => {
    const filters = FilterParamsModel.createFromFull({ ...this.state.filters, page });
    this.props.history.push(filters.toDocListUrl());
  };

  changeStatus = (statuses?: DocStatus[]) => {
    const filters = FilterParamsModel.createFromFull({ ...this.state.filters, statuses, page: undefined });
    this.props.history.push(filters.toDocListUrl());
  };

  onSearch = (text: string) => {
    const filters = FilterParamsModel.createFromFull({ ...this.state.filters, text, page: undefined });
    this.props.history.push(filters.toDocListUrl());
  };

  selectSubject = (subject: Subject) => this.props.history.push(subject.getRoute());

  doUpload = async (files: File[]) => {
    const docUploads = files.map((file, i) => (
      {
        file,
        id: i + 1,
        percentComplete: 0,
        step: DocUploadSteps.PENDING
      } as DocUpload
    ));

    const subject = this.state.selection && this.state.selection.selectedSubject.toJSON();
    const owningUnits = this.state.filters.owningUnits;
    const owningUnit = owningUnits && owningUnits.length ? owningUnits[0] : undefined;

    this.props.history.push('/doc/upload', { docUploads, subject, owningUnit });
  };

  render() {
    const { currentUser, selection, filters, docs, canUpload, loading } = this.state;

    if (!currentUser) {
      return null;
    }

    return (
      <DocListView
        currentUser={currentUser}
        selection={selection}
        filters={filters}
        docs={docs}
        canUpload={canUpload}
        doUpload={this.doUpload}
        loading={loading}
        onChangePage={this.changePage}
        onChangeStatus={this.changeStatus}
        onSearch={this.onSearch}
        onSelectSubject={this.selectSubject}
        history={this.props.history}
        location={this.props.location}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/DocListView/DocListLoader.tsx